import { Box, GridItem, useDisclosure } from '@chakra-ui/react';
import PopoverCreateProject from '../popover/PopoverCreateEditProject';

const LayoutMiniatureCreateNew = ({ gridStyle, setViewList, viewList }) => {
	//disclosure do modal de criar/editar projeto
	const { onOpen, onClose, isOpen } = useDisclosure();

	return gridStyle == 'grid' ? (
		<GridItem
			_hover={{ border: '2px dashed #ECC94B' }}
			transition={'0.1s'}
			cursor="pointer"
			maxW={'340px'}
			flex={'1 1 23%'}
			display="flex"
			justifyContent="center;"
			width={gridStyle == 'grid' ? 'auto' : '100%'}
			flexDirection="column"
			minW="271px"
			height="290px"
			border="2px dashed"
			borderColor="gray.400"
			borderRadius="lg"
			overflow="hidden"
		>
			<Box
				h={'100%'}
				display="flex"
				alignItems="center"
				placeContent="center"
				fontSize="lg"
				color="gray.700"
				fontWeight="bold"
			>
				<PopoverCreateProject {...{ setViewList, viewList, onOpen, onClose, isOpen }} />
			</Box>
		</GridItem>
	) : (
		<GridItem
			borderStyle={'solid'}
			role="group"
			margin="0 auto"
			w={'100%'}
			_hover={{ boxShadow: '0 0 2px 1pt #ECC94B' }}
			placeContent={'center'}
			alignItems={'center'}
			transition={'0.1s'}
			cursor="pointer"
			flex="1 0 100%"
			display="flex"
			flexDirection="row"
			borderWidth="1px"
			borderRadius="lg"
		>
			<Box
				display="flex"
				height="70px"
				alignItems="center"
				placeContent="center"
				fontSize="md"
				color="gray.700"
				fontWeight="bold"
			>
				<PopoverCreateProject {...{ setViewList, viewList, popoverPosition: 'bottom', onOpen, onClose, isOpen }} />
			</Box>
		</GridItem>
	);
};

export default LayoutMiniatureCreateNew;
